import * as React from 'react'
import {
  mkUntrustedPlayerEmail,
  mkUntrustedPlayerUsername,
} from '@kapitalist/contract/types'
import api from '~/api/endpoints'
import FEMLayout from '~/layouts/FEMLayout'
import type {INotSignedInRouteComponentProps} from '~/routing/Route/NotSignedIn'
import SignUpUI from './stateless'

interface IProps extends INotSignedInRouteComponentProps {}

export default class SignUpPage extends React.Component<IProps> {
  render() {
    return (
      <FEMLayout>
        <SignUpUI
          signUp={form =>
            api.auth.signUp.execute(
              {
                email: mkUntrustedPlayerEmail(form.email),
                username: mkUntrustedPlayerUsername(form.username),
                password: form.password,
              },
              {}
            )
          }
        />
      </FEMLayout>
    )
  }
}
